import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Strings from '../../../i18n';
import {
  useSetDeferEventOffMutation,
  useSetDeferEventOnMutation
} from '../../../services/device/deviceService';
import {
  StyledContainerFooterSideBar,
  StyledContainerItems,
  StyledTitleSideBar
} from '../../../components/commons/SideBarComponents/sideBarComponentsStyles';
import { GetDeferEventItem } from '../../../components/getDeferEventItem/getDeferEventItem';

interface SendDirectMethodProps {
  deviceIds: string[];
  setOpenRightSideBar: (value: boolean) => void;
  clearSelectedDevices: () => void;
}
export const SetDeferEventTime = ({
  deviceIds,
  setOpenRightSideBar,
  clearSelectedDevices
}: SendDirectMethodProps) => {
  const [
    getDeferEventOnMutation,
    { isLoading: isLoadingSetDeferOnEvent, isSuccess: isSuccessDeferEventOn }
  ] = useSetDeferEventOnMutation();
  const { locationId } = useParams();
  const [
    sendDeferEventOffMutation,
    {
      isLoading: isLoadingSetEventOFFMutation,
      isSuccess: isSuccessDeferEventOff
    }
  ] = useSetDeferEventOffMutation();

  const handleGetDeferEventOn = (date: string) => {
    getDeferEventOnMutation({
      locationId: parseInt(locationId || '', 10),
      date
    });
  };

  const handleGetDeferEventOff = (date: string) => {
    sendDeferEventOffMutation({
      locationId: parseInt(locationId || '', 10),
      date
    });
  };

  useEffect(() => {
    if (isSuccessDeferEventOff || isSuccessDeferEventOn) {
      toast.success(Strings.devices.directMethodSentSuccess);
    }
  }, [isSuccessDeferEventOff, isSuccessDeferEventOn]);

  return (
    <Box>
      <StyledContainerItems>
        <StyledTitleSideBar>
          {Strings.serverAccess.devices.setDeferTime}
        </StyledTitleSideBar>
        <GetDeferEventItem
          isSetDefer
          nameCommand={Strings.serverAccess.devices.setDeferOn}
          loading={isLoadingSetDeferOnEvent}
          onSave={handleGetDeferEventOn}
        />
        <GetDeferEventItem
          isSetDefer
          nameCommand={Strings.serverAccess.devices.setDeferOff}
          loading={isLoadingSetEventOFFMutation}
          onSave={handleGetDeferEventOff}
        />
      </StyledContainerItems>
      <StyledContainerFooterSideBar>
        <button
          type="button"
          className="btn-cancel"
          onClick={() => {
            setOpenRightSideBar(false);
            clearSelectedDevices();
          }}
        >
          {Strings.common.cancel}
        </button>
      </StyledContainerFooterSideBar>
    </Box>
  );
};
